import { Moon, Sun } from "lucide-react";
import { useBrand } from "@/context/BrandContext";

export const ThemeToggle = () => {
  const { theme, toggleTheme } = useBrand();
  const dark = theme === "dark";
  return (
    <button
      type="button"
      data-testid="theme-toggle-button"
      onClick={toggleTheme}
      aria-label={dark ? "Switch to light mode" : "Switch to dark mode"}
      className="inline-flex h-9 w-9 items-center justify-center rounded-sm border border-border bg-card text-foreground transition-colors hover:bg-muted"
    >
      {dark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </button>
  );
};
